/**
 * First we will load all of this project's JavaScript dependencies which
 * includes React and other helpers. It's a great starting point while
 * building robust, powerful web applications using React + Laravel.
 */

if (module.hot) {
    // If requested accpet HMR for the entry point
    module.hot.accept();
}

import './bootstrap';

/**
 * Next, we will create a fresh React component instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

import {register, handlePageNotFound} from './register';

register('auth.login', require('./pages/auth/Login').default);
register('auth.register', require('./pages/auth/Register').default);
register('auth.passwords.reset', require('./pages/auth/passwords/Reset').default);
register('auth.passwords.email', require('./pages/auth/passwords/Email').default);

register('users.index', require('./pages/user/Index').default);
register('users.form', require('./pages/user/Form').default);

register('notifications.index', require('./pages/notification/Index').default);

register('dashboard', require('./pages/Dashboard').default);
register('file.index', require('./pages/file/Index').default);
register('file.preview', require('./pages/file/Preview').default);

register('lifeCycleRates.index', require('./pages/lifeCycle/Index').default);
register('lifeCycleRates.form', require('./pages/lifeCycle/Form').default);

register('attributes.index', require('./pages/attribute/Index').default);
register('attributes.form', require('./pages/attribute/Form').default);

register('attributeGroups.index', require('./pages/attributeGroup/Index').default);
register('attributeGroups.form', require('./pages/attributeGroup/Form').default);
register('history.show', require('./pages/history/Show').default);

register('contacts.index', require('./pages/contacts/Index').default);
register('contacts.show', require('./pages/contacts/Show').default);
register('contacts.create', require('./pages/contacts/Create').default);
register('contacts.edit', require('./pages/contacts/Edit').default);

register('personnel.index', require('./pages/personnel/Index').default);
register('personnel.show', require('./pages/personnel/Show').default);
register('personnel.edit', require('./pages/personnel/Edit').default);

register('project.index', require('./pages/project/Index').default);
register('project.show', require('./pages/project/Show').default);
register('project.edit', require('./pages/project/Edit').default);

register('projectStatus.index', require('./pages/projectStatus/Index').default);
register('projectStatus.edit', require('./pages/projectStatus/Edit').default);
register('attachmentTypes.index', require('./pages/attachmentTypes/Index').default);

register('note.edit', require('./pages/notes/ProjectContactNoteEdit').default);
register('note.show', require('./pages/notes/ProjectContactNoteShow').default);
register('legacy', require('./pages/Legacy').default);

register('building.index', require('./pages/building/Index').default);
register('building.edit', require('./pages/building/Edit').default);
register('building.show', require('./pages/building/Show').default);

register('contract.index', require('./pages/contract/Index').default);
register('contract.edit', require('./pages/contract/Edit').default);
register('contract.show', require('./pages/contract/Show').default);

register('costCenter.index', require('./pages/costCenter/Index').default);
//register('costCenter.edit', require('./pages/costCenter/Edit').default);

// register('workTimeConfig.index', require('./pages/workTimeConfig/Index').default)
register('workTimeConfig.seasons', require('./pages/workTimeConfig/Seasons').default)
register('workTimeConfig.symbols', require('./pages/workTimeConfig/Symbols').default)

// At the end of registration we handle the case of an unmounted page load.
// This essentially means, that a laravel view without a registered
// component was loaded.
handlePageNotFound();
